var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(180deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 179, 11, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 179, 11, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,72L26.7,72C53.3,72,107,72,160,96C213.3,120,267,168,320,180C373.3,192,427,168,480,144C533.3,120,587,96,640,72C693.3,48,747,24,800,16C853.3,8,907,16,960,40C1013.3,64,1067,104,1120,136C1173.3,168,1227,192,1280,192C1333.3,192,1387,168,1440,136C1493.3,104,1547,64,1600,52C1653.3,40,1707,56,1760,52C1813.3,48,1867,24,1920,28C1973.3,32,2027,64,2080,64C2133.3,64,2187,32,2240,32C2293.3,32,2347,64,2400,100C2453.3,136,2507,176,2560,164C2613.3,152,2667,88,2720,88C2773.3,88,2827,152,2880,148C2933.3,144,2987,72,3040,60C3093.3,48,3147,96,3200,108C3253.3,120,3307,96,3360,92C3413.3,88,3467,104,3520,116C3573.3,128,3627,136,3680,144C3733.3,152,3787,160,3813,164L3840,168L3840,240L3813.3,240C3786.7,240,3733,240,3680,240C3626.7,240,3573,240,3520,240C3466.7,240,3413,240,3360,240C3306.7,240,3253,240,3200,240C3146.7,240,3093,240,3040,240C2986.7,240,2933,240,2880,240C2826.7,240,2773,240,2720,240C2666.7,240,2613,240,2560,240C2506.7,240,2453,240,2400,240C2346.7,240,2293,240,2240,240C2186.7,240,2133,240,2080,240C2026.7,240,1973,240,1920,240C1866.7,240,1813,240,1760,240C1706.7,240,1653,240,1600,240C1546.7,240,1493,240,1440,240C1386.7,240,1333,240,1280,240C1226.7,240,1173,240,1120,240C1066.7,240,1013,240,960,240C906.7,240,853,240,800,240C746.7,240,693,240,640,240C586.7,240,533,240,480,240C426.7,240,373,240,320,240C266.7,240,213,240,160,240C106.7,240,53,240,27,240L0,240Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.a4e474424eaa91c860e529ff4e14d454.svg";
export { ForwardRef as ReactComponent };